const ALL_ROLES = {
  CREATOR: {
    name: 'Creator',
    value: 'CREATOR',
  },
  GOAL_ADMIN: {
    name: 'Goal Admin',
    value: 'GOAL_ADMIN',
  },
  GOAL_CUSTOM_ADMIN: {
    name: 'Goal Custom Admin',
    value: 'GOAL_CUSTOM_ADMIN',
  },
  OWNER: {
    name: 'Owner',
    value: 'OWNER',
  },
  COLLABORATOR: {
    name: 'Collaborator',
    value: 'COLLABORATOR',
  },
  OWNER_MANAGER: {
    name: "Owner's Manager",
    value: 'OWNER_MANAGER',
  },
  COLLABORATOR_MANAGER: {
    name: "Collaborator's Manager",
    value: 'COLLABORATOR_MANAGER',
  },
  GOAL_USER: {
    name: 'Everyone',
    value: 'GOAL_USER',
  },
  MANAGER: {
    name: 'Manager',
    value: 'MANAGER',
  },
};

export type ALL_ROLES_TYPE = keyof typeof ALL_ROLES;

export const CREATE_TABLE_ROLES = [
  ALL_ROLES.GOAL_ADMIN,
  ALL_ROLES.GOAL_CUSTOM_ADMIN,
  ALL_ROLES.MANAGER,
  ALL_ROLES.GOAL_USER,
];

export const VIEW_EDIT_TABLE_ROLES = [
  ALL_ROLES.GOAL_ADMIN,
  ALL_ROLES.CREATOR,
  ALL_ROLES.GOAL_CUSTOM_ADMIN,
  ALL_ROLES.OWNER,
  ALL_ROLES.COLLABORATOR,
  ALL_ROLES.OWNER_MANAGER,
  ALL_ROLES.COLLABORATOR_MANAGER,
  ALL_ROLES.MANAGER,
  ALL_ROLES.GOAL_USER,
];

export const UPLOAD_TABLE_ROLES = [
  ALL_ROLES.GOAL_ADMIN,
  ALL_ROLES.GOAL_CUSTOM_ADMIN,
  ALL_ROLES.MANAGER,
  ALL_ROLES.GOAL_USER,
];
